import React from 'react';
import './style.css';
import Navbar from "../../Components/Navbar";
import Footer from '../../Components/Footer';

// WebpackRequire type for require.context
interface WebpackRequire extends NodeRequire {
  context(
    directory: string,
    useSubdirectories: boolean,
    regExp: RegExp
  ): {
    keys(): string[];
    (id: string): { default: string } | string;
  };
}
declare const require: WebpackRequire;

// Utility to import all images from a folder
const importAll = (r: ReturnType<WebpackRequire['context']>): string[] =>
  r.keys().map((key) => {
    const mod = r(key);
    return typeof mod === 'string' ? mod : mod.default;
  });

// Import images per category
const constructionImages = importAll(require.context('../../assests/Cons', false, /\.(png|jpe?g|svg)$/));
const concreteImages = importAll(require.context('../../assests/Conc', false, /\.(png|jpe?g|svg)$/));
const demolitionImages = importAll(require.context('../../assests/Dem', false, /\.(png|jpe?g|svg)$/));
const acImages = importAll(require.context('../../assests/Ac', false, /\.(png|jpe?g|svg)$/));
const cctvImages = importAll(require.context('../../assests/Cctv', false, /\.(png|jpe?g|svg)$/));
const paintingImages = importAll(require.context('../../assests/Painting', false, /\.(png|jpe?g|svg)$/));

// Section content descriptions (optional)
const sectionDescriptions: Record<string, string> = {
  "Construction": "New builds, additions, and structural projects.",
  "Concrete Work": "Durable and professional concrete laying and repairs.",
  "Demolition": "Safe and efficient demolition of buildings and walls.",
  "AC Services": "Installation, repair, and maintenance of all AC types.",
  "CCTV Installation": "Security systems setup and maintenance for homes and businesses.",
  "Painting": "Interior and exterior painting with high-quality finishes."




};

// Render each section with title, description, and images
const renderSection = (title: string, images: string[], description?: string) => (
  <section className="gallery-section">
 <h2 className="gallery-title">
  <span className="typing-text">{title}</span>
</h2>

    {description && <p className="gallery-description">{description}</p>}
    <div className="gallery-grid">
      {images.map((src, index) => (
       <div className="gallery-card fade-in" key={index} style={{ animationDelay: `${index * 0.05}s` }}>
  <div className="card-inner">
    <div className="card-front">
      <img src={src} alt={`${title} ${index + 1}`} className="gallery-img" />
    </div>
   
  </div>
</div>

      ))}
    </div>
  </section>
);

// Main Gallery Component
const Gallery: React.FC = () => {
  return (
    <>
      <Navbar />
      <div className="gallery-page">
        {renderSection("Construction", constructionImages, sectionDescriptions["Construction"])}
        {renderSection("Concrete Repair Works", concreteImages, sectionDescriptions["Concrete Work"])}
        {renderSection("Demolition", demolitionImages, sectionDescriptions["Demolition"])}
        {renderSection("AC Services", acImages, sectionDescriptions["AC Services"])}
        {renderSection("CCTV Installation", cctvImages, sectionDescriptions["CCTV Installation"])}
        {renderSection("Painting", paintingImages, sectionDescriptions["Painting"])}
      </div>
      <Footer/>
    </>
  );
};

export default Gallery;
